import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowRight,FiHeart,FiUsers}=FiIcons;

const Hero=()=> {
  return (
    <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-purple-900 dark:from-gray-900 dark:via-gray-800 dark:to-blue-900 min-h-screen flex items-center transition-colors duration-300">
      {/* Background Image with Subtle Gradient Opacity */}
      <div className="absolute inset-0">
        <div 
          className="w-full h-full" 
          style={{
            backgroundImage: 'url(https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1758484929585-hero_img.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: '0.85'
          }} 
        />
        {/* Subtle Gradient Overlays */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/25 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/15 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-tr from-blue-900/30 via-transparent to-purple-900/20" />
      </div>

      {/* Light mobile overlay for better readability */}
      <div className="absolute inset-0 bg-black/10 md:bg-transparent" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <motion.div
            initial={{opacity: 0,x: -50}}
            animate={{opacity: 1,x: 0}}
            transition={{duration: 0.8}}
            className="text-white"
          >
            {/* Subtle Text Shadow for Readability */}
            <motion.h1
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.8,delay: 0.2}}
              className="text-5xl lg:text-6xl font-bold mb-6 leading-tight"
              style={{textShadow: '1px 1px 4px rgba(0,0,0,0.6)'}}
            >
              Welcome to
              <span className="block text-yellow-400 dark:text-yellow-300">Southern Saviours</span>
              Church
            </motion.h1>

            <motion.p
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.8,delay: 0.4}}
              className="text-xl mb-8 text-gray-100 dark:text-gray-200 leading-relaxed"
              style={{textShadow: '1px 1px 3px rgba(0,0,0,0.5)'}}
            >
              A place of worship, community, and spiritual growth. Join us in our mission to spread love, hope, and faith throughout Port Harcourt and beyond.
            </motion.p>

            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.8,delay: 0.6}}
              className="flex flex-col sm:flex-row gap-4"
            >
              <Link
                to="/ministries"
                className="bg-yellow-500 hover:bg-yellow-600 dark:bg-yellow-400 dark:hover:bg-yellow-500 text-black font-semibold px-8 py-4 rounded-lg transition-all duration-300 flex items-center justify-center group shadow-lg"
              >
                Join Our Service
                <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </Link>
              <Link
                to="/about"
                className="border-2 border-white text-white hover:bg-white hover:text-blue-900 dark:hover:text-gray-900 font-semibold px-8 py-4 rounded-lg transition-all duration-300 backdrop-blur-sm shadow-lg text-center"
              >
                Learn More
              </Link>
            </motion.div>
          </motion.div>

          {/* Stats Cards */}
          <motion.div
            initial={{opacity: 0,x: 50}}
            animate={{opacity: 1,x: 0}}
            transition={{duration: 0.8,delay: 0.4}}
            className="grid grid-cols-1 sm:grid-cols-2 gap-6"
          >
            <div className="bg-white/10 dark:bg-gray-800/80 backdrop-blur-lg rounded-xl p-6 text-white border border-white/15 shadow-xl">
              <SafeIcon icon={FiUsers} className="w-12 h-12 text-yellow-400 dark:text-yellow-300 mb-4" />
              <h3 className="text-3xl font-bold mb-2" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.4)'}}>Connect</h3>
              <p className="text-gray-100 dark:text-gray-200" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.4)'}}>Church-On-Demand</p>
            </div>

            <div className="bg-white/10 dark:bg-gray-800/80 backdrop-blur-lg rounded-xl p-6 text-white border border-white/15 shadow-xl">
              <SafeIcon icon={FiHeart} className="w-12 h-12 text-yellow-400 dark:text-yellow-300 mb-4" />
              <h3 className="text-3xl font-bold mb-2" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.4)'}}>15+</h3>
              <p className="text-gray-100 dark:text-gray-200" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.4)'}}>Years of Service</p>
            </div>

            <div className="bg-white/10 dark:bg-gray-800/80 backdrop-blur-lg rounded-xl p-6 text-white sm:col-span-2 border border-white/15 shadow-xl">
              <div className="text-center">
                <h3 className="text-2xl font-bold mb-2" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.4)'}}>Sunday Service</h3>
                <p className="text-yellow-400 dark:text-yellow-300 text-lg">Every Sunday at 10:00 AM</p>
                <p className="text-gray-100 dark:text-gray-200 mt-2" style={{textShadow: '1px 1px 2px rgba(0,0,0,0.4)'}}>Join us for worship, fellowship, and spiritual growth</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;